module.exports = __webpack_public_path__ + "static/img/4.c1b8e90.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/4.png
// module id = nZb1
// module chunks = 0